var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Layout, Loading } from "../..";
import RenderIfVisible from "./RenderIfVisible";
var VirtualizedList = function (props) {
    // Show loading indicator
    if (props.isLoading) {
        return (_jsx(Layout.PageLoading, { children: _jsx(Loading, { size: 75 }) }));
    }
    return (_jsxs("div", { children: [props.header && props.header, props.items.map(function (item) { return (_jsx(RenderIfVisible, __assign({ defaultHeight: props.itemDefaultHeight }, { children: item.node }), item.key)); }), props.footer && props.footer] }));
};
export default VirtualizedList;
//# sourceMappingURL=index.js.map